import { render } from "./reportsByResourceMainPage.vue?vue&type=template&id=58f81d65"
import script from "./reportsByResourceMainPage.vue?vue&type=script&lang=js"
export * from "./reportsByResourceMainPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__